(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/views/start.js') >= 0) return;  svs.modules.push('/modules/iam-idp/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.iam_idp=_svs.iam_idp||{};
_svs.iam_idp.templates=_svs.iam_idp.templates||{};
svs.iam_idp.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"containerRegion\" class=\"js-react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-iam_idp-start'] = svs.iam_idp.templates.start;
})(svs, Handlebars);


 })(window);